import React from "react";
export default function NearMe(props) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="13.774" height="13.774">
			<path d="M13.774 0 0 5.762v.75L5.234 8.54l2.02 5.234H8Z" fill={props.color || "#2d6fa7"} />
		</svg>
	);
}

export function LocationLg() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="64" height="64">
			<path d="M64 0 0 26.773v3.484l24.32 9.423L33.707 64h3.484Z" fill={props.color || "#2d6fa7"} />
		</svg>
	);
}
